import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HrInviteEmployeeDateRangeComponent } from './hr-invite-employee-date-range.component';

@Injectable()
export class HrInviteEmployeeDateRangeDialogService {
  private readonly dialog = inject(MatDialog);

  show(
    toDate: string,
    options?: {
      isInviteBlocked?: boolean;
      inviteBlockedTooltipKey?: string;
    }
  ) {
    return this.dialog
      .open(HrInviteEmployeeDateRangeComponent, {
        disableClose: true,
        width: '650px',
        data: {
          toDate,
          isInviteBlocked: options?.isInviteBlocked ?? false,
          inviteBlockedTooltipKey: options?.inviteBlockedTooltipKey,
        },
      })
      .afterClosed()
      .toPromise();
  }
}
